import {
  FlagRU,
  FlagAC,
  FlagAF,
  FlagAR,
  FlagAS,
  FlagAU,
  FlagBD,
  FlagBE,
  FlagBO,
  FlagBR,
  FlagCA,
  FlagCL,
  FlagCO,
  FlagCZ,
  FlagDE,
  FlagDK,
  FlagEC,
  FlagEE,
  FlagES,
  FlagFR,
  FlagHR,
  FlagID,
  FlagIE,
  FlagIN,
  FlagIT,
  FlagLA,
  FlagLT,
  FlagLV,
  FlagPA,
  FlagUS,
  FlagMX,
  FlagPT,
  FlagSA,
  FlagBG,
  FlagGR,
  FlagFI,
  FlagIL,
  FlagHU,
  FlagKR,
  FlagNL,
  FlagNO,
  FlagPL,
  FlagRO,
  FlagSK,
  FlagSI,
  FlagRS,
  FlagSE,
  FlagTH,
  FlagTR,
  FlagUA,
  FlagVN,
  FlagJP,
  FlagHK,
  FlagTW,
  FlagTN,
  FlagLK,
  FlagVE,
  FlagUY,
  FlagGB,
  FlagAE,
  FlagCH,
  FlagZA,
  FlagSG,
  FlagPR,
  FlagPH,
  FlagPE,
  FlagPY,
  FlagPK,
  FlagNA,
  FlagNG,
  FlagNZ,
  FlagMA,
  FlagMY,
  FlagKE,
  FlagKZ,
  FlagJM,
  FlagEG,
  FlagCN,
  FlagAT,
  FlagAO
} from "@veneer/flags";

export const countries = [
  {
    name: "Africa",
    lang: "en",
    code: "en-emea_africa",
    flag: <FlagAF size={24} disabled={false} />,
  },
  {
    name: "Japan",
    lang: "ja",
    code: "jp",
    flag: <FlagJP size={24} disabled={false} />,
  },
  {
    name: "Vietnam",
    lang: "vi",
    code: "vn",
    flag: <FlagVN size={24} disabled={false} />,
  },
  {
    name: "Ukraine",
    lang: "uk",
    code: "ua",
    flag: <FlagUA size={24} disabled={false} />,
  },
  {
    name: "Turkey",
    lang: "tr",
    code: "tr",
    flag: <FlagTR size={24} disabled={false} />,
  },
  {
    name: "Thailand",
    lang: "th",
    code: "th",
    flag: <FlagTH size={24} disabled={false} />,
  },
  {
    name: "Sweden",
    lang: "sv",
    code: "se",
    flag: <FlagSE size={24} disabled={false} />,
  },
  {
    name: "Serbia",
    lang: "sr",
    code: "rs",
    flag: <FlagRS size={24} disabled={false} />,
  },
  {
    name: "Slovenia",
    lang: "sl",
    code: "si",
    flag: <FlagSI size={24} disabled={false} />,
  },
  {
    name: "Slovakia",
    lang: "sk",
    code: "sk",
    flag: <FlagSK size={24} disabled={false} />,
  },
  {
    name: "Romania",
    lang: "ro",
    code: "ro",
    flag: <FlagRO size={24} disabled={false} />,
  },
  {
    name: "Poland",
    lang: "pl",
    code: "pl",
    flag: <FlagPL size={24} disabled={false} />,
  },
  {
    name: "Norway",
    lang: "no",
    code: "no",
    flag: <FlagNO size={24} disabled={false} />,
  },
  {
    name: "Netherlands",
    lang: "nl",
    code: "nl",
    flag: <FlagNL size={24} disabled={false} />,
  },
  {
    name: "Portugal",
    lang: "pt",
    code: "pt",
    flag: <FlagPT size={24} disabled={false} />,
  },
  {
    name: "South Korea",
    lang: "ko",
    code: "kr",
    flag: <FlagKR size={24} disabled={false} />,
  },
  {
    name: "Israel",
    lang: "he",
    code: "il",
    flag: <FlagIL size={24} disabled={false} />,
  },
  {
    name: "Hungary",
    lang: "hu",
    code: "hu",
    flag: <FlagHU size={24} disabled={false} />,
  },
  {
    name: "Finland",
    lang: "fi",
    code: "fi",
    flag: <FlagFI size={24} disabled={false} />,
  },
  {
    name: "Greece",
    lang: "el",
    code: "gr",
    flag: <FlagGR size={24} disabled={false} />,
  },
  {
    name: "Saudi Arabia",
    lang: "ar",
    code: "sa",
    flag: <FlagSA size={24} disabled={false} />,
  },
  {
    name: "Bulgaria",
    lang: "bg",
    code: "bg",
    flag: <FlagBG size={24} disabled={false} />,
  },
  {
    name: "Mexico",
    lang: "es",
    code: "mx",
    flag: <FlagMX size={24} disabled={false} />,
  },
  {
    name: "Brazil",
    lang: "pt",
    code: "pt",
    flag: <FlagBR size={24} disabled={false} />,
  },
  {
    name: "Russia",
    lang: "en",
    code: "en-emea_africa",
    flag: <FlagRU size={24} disabled={false} />,
  },
  {
    name: "Afrique",
    lang: "fr",
    code: "fr-emea_africa",
    flag: <FlagFR size={24} disabled={false} />,
  },
  {
    name: "América Central",
    lang: "es",
    code: "es-lamerica_nsc_cnt_amer",
    flag: <FlagAC size={24} disabled={false} />,
  },
  {
    name: "Argentina",
    lang: "es",
    code: "es-ar",
    flag: <FlagAR size={24} disabled={false} />,
  },
  {
    name: "Asia Pacific",
    lang: "en",
    code: "en-asiapac",
    // flag: <FlagAS size={24} disabled={false} />
  },
  {
    name: "Australia",
    lang: "en",
    code: "en-au",
    flag: <FlagAU size={24} disabled={false} />,
  },
  {
    name: "Bangladesh",
    lang: "bn",
    code: "bn-bd",
    flag: <FlagBD size={24} disabled={false} />,
  },
  {
    name: "Bolivia",
    lang: "es",
    code: "es-bo",
    flag: <FlagBO size={24} disabled={false} />,
  },
  {
    name: "Brasil",
    lang: "pt",
    code: "pt-br",
    flag: <FlagBR size={24} disabled={false} />,
  },
  {
    name: "Canada",
    lang: "en",
    code: "en-ca",
    flag: <FlagCA size={24} disabled={false} />,
  },
  {
    name: "Canada - Français",
    lang: "fr",
    code: "fr-ca",
    flag: <FlagCA size={24} disabled={false} />,
  },
  {
    name: "Caribbean",
    lang: "en",
    code: "en-lamerica_nsc_carib",
    // flag: <FlagLA size={24} disabled={false} />
  },
  {
    name: "Czech Republic",
    lang: "cs",
    code: "cz",
    flag: <FlagCZ size={24} disabled={false} />,
  },
  {
    name: "Chile",
    lang: "es",
    code: "es-cl",
    flag: <FlagCL size={24} disabled={false} />,
  },
  {
    name: "Colombia",
    lang: "es",
    code: "es-co",
    flag: <FlagCO size={24} disabled={false} />,
  },
  {
    name: "Denmark",
    lang: "da",
    code: "dk",
    flag: <FlagDK size={24} disabled={false} />,
  },
  {
    name: "Germany",
    lang: "de",
    code: "de",
    flag: <FlagDE size={24} disabled={false} />,
  },
  {
    name: "Ecuador",
    lang: "es",
    code: "es-ec",
    flag: <FlagEC size={24} disabled={false} />,
  },
  {
    name: "Estonia",
    lang: "et",
    code: "ee",
    flag: <FlagEE size={24} disabled={false} />,
  },
  {
    name: "English",
    lang: "en",
    code: "en-us",
    flag: <FlagUS size={24} disabled={false} />,
  },
  {
    name: "Spain",
    lang: "es",
    code: "es-es",
    flag: <FlagES size={24} disabled={false} />,
  },
  {
    name: "France",
    lang: "fr",
    code: "fr-fr",
    flag: <FlagFR size={24} disabled={false} />,
  },
  {
    name: "Hong Kong",
    lang: "zh",
    code: "zh-hk",
    flag: <FlagHK size={24} disabled={false} />,
  },
  {
    name: "Taiwan",
    lang: "tw",
    code: "zh-tw",
    flag: <FlagTW size={24} disabled={false} />,
  },
  {
    name: "Tunisia",
    lang: "en",
    code: "en-ts",
    flag: <FlagTN size={24} disabled={false} />,
  },
  {
    name: "Croatia",
    lang: "hr",
    code: "hr",
    flag: <FlagHR size={24} disabled={false} />,
  },
  {
    name: "India",
    lang: "en",
    code: "en-in",
    flag: <FlagIN size={24} disabled={false} />,
  },
  {
    name: "Indonesia",
    lang: "id",
    code: "id-id",
    flag: <FlagID size={24} disabled={false} />,
  },
  {
    name: "Ireland",
    lang: "en",
    code: "en-ie",
    flag: <FlagIE size={24} disabled={false} />,
  },
  {
    name: "Italy",
    lang: "it",
    code: "it",
    flag: <FlagIT size={24} disabled={false} />,
  },
  {
    name: "Latvia",
    lang: "lv",
    code: "lv",
    flag: <FlagLV size={24} disabled={false} />,
  },
  {
    name: "Lithuania",
    lang: "lt",
    code: "lt-lt",
    flag: <FlagLT size={24} disabled={false} />,
  },
  {
    name: "United States",
    lang: "en",
    code: "en-us",
    flag: <FlagUS size={24} disabled={false} />,
  },
  {
    name: "Sri Lanka",
    lang: "en",
    code: "en-lk",
    flag: <FlagLK size={24} disabled={false} />,
  },
  {
    name: "Venezuela",
    lang: "es",
    code: "es-ve",
    flag: <FlagVE size={24} disabled={false} />,
  },
  {
    name: "Uruguay",
    lang: "es",
    code: "es-uy",
    flag: <FlagUY size={24} disabled={false} />,
  },
  {
    name: "United Kingdom",
    lang: "es",
    code: "es-uk",
    flag: <FlagGB size={24} disabled={false} />,
  },
  {
    name: "United Arab Emirates",
    lang: "es",
    code: "es-ae",
    flag: <FlagAE size={24} disabled={false} />,
  },
  {
    name: "Turkiye",
    lang: "es",
    code: "es-tr",
    flag: <FlagTR size={24} disabled={false} />,
  },
  {
    name: "Switzerland",
    lang: "es",
    code: "es-ch",
    flag: <FlagCH size={24} disabled={false} />,
  },
  {
    name: "South Africa",
    lang: "es",
    code: "es-za",
    flag: <FlagZA size={24} disabled={false} />,
  },
  {
    name: "Singapore",
    lang: "es",
    code: "es-sg",
    flag: <FlagSG size={24} disabled={false} />,
  },
  {
    name: "Puerto Rico",
    lang: "es",
    code: "es-pr",
    flag: <FlagPR size={24} disabled={false} />,
  },
  {
    name: "Philippines",
    lang: "es",
    code: "es-ph",
    flag: <FlagPH size={24} disabled={false} />,
  },
  {
    name: "Peru",
    lang: "es",
    code: "es-pe",
    flag: <FlagPE size={24} disabled={false} />,
  },
  {
    name: "Paraguay",
    lang: "es",
    code: "es-py",
    flag: <FlagPY size={24} disabled={false} />,
  },
  {
    name: "Panama",
    lang: "es",
    code: "es-pa",
    flag: <FlagPA size={24} disabled={false} />,
  },
  {
    name: "Pakistan",
    lang: "es",
    code: "es-pk",
    flag: <FlagPK size={24} disabled={false} />,
  },
  {
    name: "North America",
    lang: "es",
    code: "es-na",
    flag: <FlagNA size={24} disabled={false} />,
  },
  {
    name: "Nigeria",
    lang: "es",
    code: "es-ng",
    flag: <FlagNG size={24} disabled={false} />,
  },
  {
    name: "New Zealand",
    lang: "es",
    code: "es-nz",
    flag: <FlagNZ size={24} disabled={false} />,
  },
  {
    name: "Morocco",
    lang: "es",
    code: "es-ma",
    flag: <FlagMA size={24} disabled={false} />,
  },
  {
    name: "Malaysia",
    lang: "es",
    code: "es-my",
    flag: <FlagMY size={24} disabled={false} />,
  },
  {
    name: "Latin America",
    lang: "es",
    code: "es-la",
    flag: <FlagLA size={24} disabled={false} />,
  },
  {
    name: "Korea",
    lang: "es",
    code: "es-kr",
    flag: <FlagKR size={24} disabled={false} />,
  },
  {
    name: "Kenya",
    lang: "es",
    code: "es-ke",
    flag: <FlagKE size={24} disabled={false} />,
  },
  {
    name: "Kazakhstan",
    lang: "es",
    code: "es-kz",
    flag: <FlagKZ size={24} disabled={false} />,
  },
  {
    name: "Jamaica",
    lang: "es",
    code: "es-jm",
    flag: <FlagJM size={24} disabled={false} />,
  },
  {
    name: "Egypt",
    lang: "es",
    code: "es-eg",
    flag: <FlagEG size={24} disabled={false} />,
  },
  {
    name: "China",
    lang: "es",
    code: "es-cn",
    flag: <FlagCN size={24} disabled={false} />,
  },
  {
    name: "Belgium",
    lang: "es",
    code: "es-be",
    flag: <FlagBE size={24} disabled={false} />,
  },
  {
    name: "Austria",
    lang: "es",
    code: "es-at",
    flag: <FlagAT size={24} disabled={false} />,
  },
  {
    name: "Angola",
    lang: "es",
    code: "es-ao",
    flag: <FlagAO size={24} disabled={false} />,
  },
];